declare namespace $ {

	type $mol_string__value_shm_hitalama_vk_group_search_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['search_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_major__title_shm_hitalama_vk_group_search_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_vk_group_search_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['search'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__hint_shm_hitalama_vk_group_search_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_labeler__label_shm_hitalama_vk_group_search_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['search_label'] >
		,
		ReturnType< $mol_labeler['label'] >
	>
	type $mol_labeler__content_shm_hitalama_vk_group_search_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_image__uri_shm_hitalama_vk_group_search_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['photo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_group_search_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_vk_group_search_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_group_search_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_group_search_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_vk_group_search_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_group_search['error_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_vk_group_search extends $mol_view {
		search_title( ): string
		search_label( ): readonly($mol_view_content)[]
		search_value( next?: string ): string
		Group_id( ): $mol_string
		search( next?: any ): any
		Search( ): $mol_button_major
		Search_label( ): $mol_labeler
		photo_uri( ): string
		Photo( ): $mol_image
		name( ): string
		Name( ): $mol_paragraph
		Members_count_icon( ): $mol_icon_account_group_outline
		members_count( next?: string ): string
		Members_count( ): $mol_view
		Name_block( ): $mol_view
		buttons( ): readonly(any)[]
		Group( ): $mol_view
		search_result_view( ): readonly(any)[]
		error_message( ): string
		token_str( ): string
		group_id( ): string
		owner_id( ): string
		search_result( next?: any ): any
		reset( ): any
		dto( ): $shm_hitalama_vk_group_dto | null
		search_click( ): any
		sub( ): readonly(any)[]
		Search_error( ): $mol_text
	}
	
}

//# sourceMappingURL=search.view.tree.d.ts.map